import { getData, postData, deleteData, putData } from './apiService';  // Assuming getData is a function that fetches data from your API
import { CreateRegistrant, EnrichedRegistrant, RegistrantAnswer, RegistrantRanking, UpdateRegistrant } from '../types/Registrant'; // Import the RegistrantAnswer type

export const fetchRegistrantsByEventId = async (eventId: string): Promise<EnrichedRegistrant[]> => {
  try {
    const response = await getData(`/events/${eventId}/registrants`, {});
    // Return the response as an array of RegistrantAnswer objects
    return response.data as EnrichedRegistrant[];
  } catch (error) {
    console.error('Failed to fetch registrants:', error);
    return []; // Return an empty array in case of error
  }
};

export const fetchMyRegistrantByEventId = async (eventId: string): Promise<EnrichedRegistrant | null> => {
  try {
    const response = await getData(`/events/${eventId}/my-registrant`, {});
    // Return the response as an array of RegistrantAnswer objects
    return response.data as EnrichedRegistrant;
  } catch (error) {
    console.error('Failed to fetch event registrant:', error);
    return null; // Return an empty array in case of error
  }
};


export const fetchRegistrantsByOrganizationId = async (organizationId: string): Promise<EnrichedRegistrant[]> => {
  try {
    const response = await getData(`/organizations/${organizationId}/registrants`, {});
    // Return the response as an array of RegistrantAnswer objects
    return response.data as EnrichedRegistrant[];

  } catch (error) {
    console.error('Failed to fetch registrants:', error);
    return []; // Return an empty array in case of error
  }
};

export const fetchRegistrantsByOrganizationIdAndEventId = async (organizationId: string, eventId: string): Promise<EnrichedRegistrant[]> => {
  try {
    const response = await getData(`/events/${eventId}/organization/${organizationId}/registrants`, {});
    // Return the response as an array of RegistrantAnswer objects
    return response.data as EnrichedRegistrant[];

  } catch (error) {
    console.error('Failed to fetch registrants:', error);
    return []; // Return an empty array in case of error
  }
};

export const fetchUserRegistrantsByEventId = async (eventId: string): Promise<EnrichedRegistrant[]> => {
  try {
    const response = await getData(`/events/${eventId}/my-registrants`, {});
    // Return the response as an array of RegistrantAnswer objects
    return response.data as EnrichedRegistrant[];

  } catch (error) {
    console.error('Failed to fetch registrants:', error);
    return []; // Return an empty array in case of error
  }
};

// Fetch a specific registrant by ID
export const fetchRegistrantById = async (registrantId: string): Promise<EnrichedRegistrant | null> => {
  try {
    const response = await getData(`/registrants/${registrantId}`, {});
    return response.data as EnrichedRegistrant; // Handle it as needed
  } catch (error) {
    console.error('Failed to fetch registrant:', error);
    throw error;  // Handle error as needed
  }
};

// Fetch registrants by organization and last name
export const fetchRegistrantsByOrganizationAndLastName = async (organizationId: string, lastName: string) => {
  try {
    const response = await getData(`/registrants/organization/${organizationId}/lastname/${lastName}`, {});
    return response.data;
  } catch (error) {
    console.error('Failed to fetch registrants:', error);
    throw error;
  }
};

// Create a new registrant
export const createRegistrant = async (registrantData: CreateRegistrant): Promise<string> => {
  try {
    const response = await postData('/registrants', registrantData);
    return response.data.registrant_id; // Handle the response data accordingly
  } catch (error) {
    console.error('Failed to create registrant:', error);
    throw error;  // Handle error as needed
  }
};

// Update a registrant
export const updateRegistrant = async (registrantId: string, updatedData: UpdateRegistrant): Promise<boolean> => {
  try {
    const response = await putData(`/registrants/${registrantId}`, updatedData); // `putData` could be used if you have a specific function
    return response.success;
  } catch (error) {
    console.error('Failed to update registrant:', error);
    throw error;
  }
};

// Delete a registrant (soft delete)
export const deleteRegistrant = async (registrantId: string) => {
  try {
    const response = await deleteData(`/registrants/${registrantId}`, {}); // Replace with `deleteData` if you have it
    return response.data;
  } catch (error) {
    console.error('Failed to delete registrant:', error);
    throw error;
  }
};

// Check-in a registrant
export const checkInRegistrant = async (registrantId: string) => {
  try {
    const response = await postData(`/registrants/${registrantId}/check-in`, {});
    return response.data;
  } catch (error) {
    console.error('Failed to check-in registrant:', error);
    throw error;
  }
};

// Uncheck-in a registrant
export const unCheckInRegistrant = async (registrantId: string) => {
  try {
    const response = await postData(`/registrants/${registrantId}/uncheck-in`, {});
    return response.data;
  } catch (error) {
    console.error('Failed to uncheck-in registrant:', error);
    throw error;
  }
};

// Mark a registrant as attending
export const markAsAttending = async (registrantId: string) => {
  try {
    const response = await postData(`/registrants/${registrantId}/attending`, {});
    return response.data;
  } catch (error) {
    console.error('Failed to mark registrant as attending:', error);
    throw error;
  }
};

// Mark a registrant as not attending
export const markAsNotAttending = async (registrantId: string) => {
  try {
    const response = await postData(`/registrants/${registrantId}/not-attending`, {});
    return response.data;
  } catch (error) {
    console.error('Failed to mark registrant as not attending:', error);
    throw error;
  }
};

// Mark a registrant as invited
export const markAsInvited = async (registrantId: string) => {
  try {
    const response = await postData(`/registrants/${registrantId}/invited`, {});
    return response.data;
  } catch (error) {
    console.error('Failed to mark registrant as invited:', error);
    throw error;
  }
};

// Mark a registrant as not invited
export const markAsNotInvited = async (registrantId: string) => {
  try {
    const response = await postData(`/registrants/${registrantId}/not-invited`, {});
    return response.data;
  } catch (error) {
    console.error('Failed to mark registrant as not invited:', error);
    throw error;
  }
};


export const getRegistrantsByEmailLastNameEventIdForCheckin = async (email: string, last_name: string, event_id: string) => {
  try {
    const response = await getData('/registrants',{email, last_name, event_id});
    return response.data;
  } catch (error) {
    console.error('Failed to mark registrant as not invited:', error);
    throw error;
  }
};


export const sendSelfCheckinRegistrant = async (registrant_id: string, event_id: string): Promise<boolean> => {
  try {
    const response = await postData(`/events/${event_id}/self-check-in/${registrant_id}`,{});
    return response.success;
  } catch (error) {
    console.error('Failed to mark registrant as not invited:', error);
    throw error;
  }
};


export const postRankings = async (rankings: RegistrantRanking[]): Promise<boolean> => {
  try {
    const response = await putData(`/registrant-rankings`, { rankings: rankings } );
    return response.success;
  } catch (error) {
    console.error('Failed to update rankings');
    throw error;
  }
}